export const leftArrowPosition = 'mt-4 start-24';
export const rightArrowPosition = 'mt-4 ltr:start-[unset] rtl:right-[unset] -end-16';
